module.exports = __webpack_public_path__ + "images/album_600.6d42fe94a1769346339e836656b828e3.png";